export default {
  login: 'signin.login',
  title: 'signin.title',
  freeTrial: 'signin.freeTrial',
  forgotPassword: 'signin.forgotPassword',
  inputLabel1: 'signin.inputLabel1',
  inputLabel2: 'signin.inputLabel2',
};
